<mat-card appearance="outlined" class="redis-card">
  <div class="header row">
    <div>
      <h2>Redis</h2>
    </div>
    <app-status-label [status]="status()"></app-status-label>
  </div>

  <div class="elevated row">
    <div class="column">
      <h5>Redis Cache</h5>
      <span>Enable Redis for this site </span>
    </div>
    <mat-slide-toggle
      [checked]="cacheEnabled()"
      (change)="onCacheToggleChange($event)"
      [disabled]="pending()"
    ></mat-slide-toggle>
  </div>

  <div class="buttons row">
    <button matButton="filled">
      <fa-icon [icon]="['fas', 'eraser']" size="lg"></fa-icon>
      Clear Redis Cache
    </button>

    <button matButton="outlined" (click)="syncStatus()" [disabled]="syncing()">
      <fa-icon [icon]="['fas', 'arrows-rotate']" size="lg"></fa-icon>
      Sync Redis Status
    </button>
  </div>
</mat-card>
